// ── IMAGE SLOTS (Catechist Ready) ────────────────────────────
// Hosted in the Impultienda store resources (Recursos).
const STORE = '8d432786-0968-4171-9a5e-fb735bde5535';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Gamma Studio cover plus
 * real pages 4 and 11 on the iMac, and the Impultienda bonus photos with their titles typed in. Pure white background.
 */
const IMAC = RES + '1792673150534_cat-mockup-imac-dd63d9c0.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as lookInside.captions: p.4, 11, 12, 13, 37, 39
 *  (pages checked clean in QC; session 02 is shown complete in its 3 pages). */
export const pageImages: string[] = [
  RES + '1792673174626_cat-pagina-04-plan-otono-279dcd3e.webp',
  RES + '1792673178800_cat-pagina-11-sesion-02-plan-5739e419.webp',
  RES + '1792673182770_cat-pagina-12-sesion-02-historia-c4930c80.webp',
  RES + '1792673187344_cat-pagina-13-sesion-02-actividad-e85957ff.webp',
  RES + '1792673191817_cat-pagina-37-sesion-10-comunion-4a80f949.webp',
  RES + '1792673195794_cat-pagina-39-planner-2580f1eb.webp',
];
/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792673154387_cat-bono-1-juegos-8a719833.webp',
  RES + '1792673158188_cat-bono-2-adviento-86618a05.webp',
  RES + '1792673162674_cat-bono-3-reconciliacion-a81d85b5.webp',
  RES + '1792673167080_cat-bono-4-padres-2608168b.webp',
  RES + '1792673170926_cat-bono-5-dre-00cdeae4.webp',
];
